module.exports = __webpack_public_path__ + "img/Body_feathers_DiffuseColor.5bf8f81.png";